const search = {
  allResults: Drupal.t('Show all results'),
  for: Drupal.t('for'),
  placeholder: Drupal.t('Search ...'),
  searchRelated: Drupal.t('Related search inputs'),
  startSearching: Drupal.t('Start searching'), // this wording is weird
  startSearchingText: Drupal.t(
    'Try our search bar at the top right to find products, crops, services and all the information you need.',
  ),
  searchResultsTitle: Drupal.t('Search results'),
};

export default search;
